import React from 'react';
import { Modal, ModalHeader, Row, Col, Card, CardBody } from 'reactstrap';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import {
    getStateSpecificAWSLogo as getAWSLogo,
    getStateSpecificNRLogo as getNRLogo,
    getStateSpecificAzureLogo as getAzureLogo,
    getStateSpecificGCPLogo as getGCPLogo,
    getStateSpecificDatadogLogo,
    getStateSpecificSplunkLogo,
    getStateSpecificADLogo as getADLogo, getDynatraceLogo

} from "../../../helpers/component_helpers";

function MapPagerDutyModal({
    type,
    isOpen,
    checkBox,
    filteredResources,
    handleCheckBox,
    pagerdutyServiceOptions,
    environments,
    handlePDFormChange,
    handleEnvironmentChange,
    startLoading1,
    handlePagerdutyServiceMapping,
    cancelMapResourcePagerdutyServiceModal,
    customStyles
}) { 
    
    return (
        <Modal isOpen={isOpen} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static" size="xl" data-toggle="modal">
            <div>
                <ModalHeader className="border-bottom-2">
                    <span className="modal-header-resource">Map Resources to Pagerduty Service</span>
                </ModalHeader>
            </div>
            <div className="modal-body">
                <Row className="full-width">
                    <Col lg="7" className="">
                        <h5 className="text-primary mb-3">Selected Resources</h5>
                        <Row>
                            {Object.keys(checkBox).map((key, index) => {
                                if (checkBox[key] === true) {
                                    return (
                                        <Col md="6" key={key}>
                                            <div className="border border-white bg-transparent text-white px-2 my-1">
                                                <CardBody className="p-0">
                                                    <div className="resource-logo-display mt-1">
                                                        {
                                                            <img src={type === "AWS" ? getAWSLogo(
                                                                filteredResources[key].resource_name, filteredResources[key].state) : type === "GCP" ? getGCPLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                                                : type==='Azure' ? getAzureLogo(filteredResources[key].resource_name, filteredResources[key].state): type === "Datadog" ? getStateSpecificDatadogLogo(filteredResources[key].resource_name, true)
                                                                    : type === 'NewRelic' ? getNRLogo(filteredResources[key].resource_name, filteredResources[key].is_application_active)
                                                                      : type === "Splunk" ? getStateSpecificSplunkLogo(filteredResources[key].resource_name, true)
                                                                            :type === 'Dynatrace' ? getDynatraceLogo(filteredResources[key].resource_name, true)
                                                                        : getADLogo(filteredResources[key].resource_name, true)} className="resource-logo" alt="Resource Logo" />

                                                        }
                                                        <h6 className="pt-2 resource-name-truncate">
                                                            {filteredResources[key].name}
                                                        </h6>
                                                    </div>
                                                </CardBody>
                                                <span className="close me-2" onClick={() => handleCheckBox(key)}></span>
                                            </div>
                                        </Col>
                                    );
                                }
                            })}
                        </Row>
                    </Col>
                    <Col lg="5" className="">
                        <h5 className="text-primary select-service mb-3">Select Pagerduty Service</h5>
                        <div className="text-center mb-4">
                            <div className="row justify-content-center">
                                <div className="col-xl-10">
                                    <div className="mb-2">
                                        <Select
                                            isClearable
                                            options={pagerdutyServiceOptions}
                                            placeholder="Select a Pagerduty Service"
                                            onChange={event => handlePDFormChange(event)}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    neutral0: '#222736',
                                                    neutral5: '#485EC4',
                                                    neutral10: '#485EC4',
                                                    neutral60: '#ffffff',
                                                    neutral70: '#ffffff',
                                                    neutral80: '#ffffff',
                                                    neutral90: '#ffffff',
                                                    primary: '#485EC4',
                                                },
                                            })}
                                            styles={customStyles}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            isClearable
                                            options={environments}
                                            placeholder="Select an Environment"
                                            onChange={event => handleEnvironmentChange(event)}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    neutral0: '#222736',
                                                    neutral5: '#485EC4',
                                                    neutral10: '#485EC4',
                                                    neutral60: '#ffffff',
                                                    neutral70: '#ffffff',
                                                    neutral80: '#ffffff',
                                                    neutral90: '#ffffff',
                                                    primary: '#485EC4',
                                                },
                                            })}
                                            styles={customStyles}
                                        />
                                    </div>
                                    <Row className="full-width mt-4 pt-4">
                                        <Col lg="6" className="mt-4">
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                cancelMapResourcePagerdutyServiceModal();
                                            }} className="btn btn-secondary w-md">Cancel</a>
                                        </Col>
                                        <Col lg="6" className="mt-4">
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                startLoading1();
                                                handlePagerdutyServiceMapping();
                                            }} className="btn btn-primary w-md">Map</a>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
}

export default MapPagerDutyModal;